import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Table, Typography } from 'antd';

const { Title } = Typography;

export default function MassImportPreview({
  selectedSheet,
  headerMapping,
  importTypeConfig,
  headers: headersProp,
}) {
  const headers = headersProp || importTypeConfig?.headers || [];

  const previewData = useMemo(() => {
    if (!selectedSheet || !headerMapping || !headers.length) return [];

    // Map the data using the header mappings
    return selectedSheet.slice(0, 10).map((row, index) => {
      const mappedRow = { key: index };
      headers.forEach((header) => {
        const excelColumn = headerMapping[header.key];
        if (excelColumn && row[excelColumn] !== undefined) {
          mappedRow[header.key] = row[excelColumn];
        }
      });
      return mappedRow;
    });
  }, [selectedSheet, headerMapping, headers]);

  const columns = useMemo(() => (
    headers
      .filter((header) => headerMapping[header.key])
      .map((header) => ({
        title: header.title,
        dataIndex: header.key,
        key: header.key,
        ellipsis: true,
      }))
  ), [headers, headerMapping]);

  return (
    <div>
      <Title level={4}>Preview (First 10 rows)</Title>
      <Table
        columns={columns}
        dataSource={previewData}
        pagination={false}
        scroll={{ x: 'max-content' }}
        size="small"
      />
      <div style={{ marginTop: 16, color: '#666' }}>
        Total rows to import: {selectedSheet?.length || 0}
      </div>
    </div>
  );
}

MassImportPreview.propTypes = {
  selectedSheet: PropTypes.arrayOf(PropTypes.object),
  headerMapping: PropTypes.shape({}),
  importTypeConfig: PropTypes.shape({
    headers: PropTypes.arrayOf(
      PropTypes.shape({
        key: PropTypes.string,
        title: PropTypes.string,
        required: PropTypes.bool,
      }),
    ),
  }),
  headers: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      title: PropTypes.string,
      required: PropTypes.bool,
    }),
  ),
};

MassImportPreview.defaultProps = {
  selectedSheet: [],
  headerMapping: {},
  importTypeConfig: null,
  headers: null,
};
